module.exports = __webpack_public_path__ + "static/media/remove.29394a6c.svg";